module.exports = __webpack_public_path__ + "img/hlj.a2e510f3.png";